// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_I18n_Types from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic_Menu_V2_Types_Allergen from "../Restaumatic.Menu.V2.Types.Allergen/index.js";
import * as Restaumatic_Menu_V2_Types_Availability from "../Restaumatic.Menu.V2.Types.Availability/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_PackagingContainer from "../Restaumatic.Menu.V2.Types.PackagingContainer/index.js";
import * as Restaumatic_Menu_V2_Types_Parametric_Parametric from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
import * as Restaumatic_Menu_V2_Types_Photo from "../Restaumatic.Menu.V2.Types.Photo/index.js";
import * as Restaumatic_Menu_V2_Types_Taxes from "../Restaumatic.Menu.V2.Types.Taxes/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var IncludedInProduct = /* #__PURE__ */ (function () {
    function IncludedInProduct() {

    };
    IncludedInProduct.value = new IncludedInProduct();
    return IncludedInProduct;
})();
var Separate = /* #__PURE__ */ (function () {
    function Separate(value0) {
        this.value0 = value0;
    };
    Separate.create = function (value0) {
        return new Separate(value0);
    };
    return Separate;
})();
var ModifierItem = function (x) {
    return x;
};
var ModifierItemSection = function (x) {
    return x;
};
var ModifierList = /* #__PURE__ */ (function () {
    function ModifierList() {

    };
    ModifierList.value = new ModifierList();
    return ModifierList;
})();
var ModifierCheckboxList = /* #__PURE__ */ (function () {
    function ModifierCheckboxList() {

    };
    ModifierCheckboxList.value = new ModifierCheckboxList();
    return ModifierCheckboxList;
})();
var ModifierRadioButtonList = /* #__PURE__ */ (function () {
    function ModifierRadioButtonList() {

    };
    ModifierRadioButtonList.value = new ModifierRadioButtonList();
    return ModifierRadioButtonList;
})();
var ModifierPizzaGrid = /* #__PURE__ */ (function () {
    function ModifierPizzaGrid() {

    };
    ModifierPizzaGrid.value = new ModifierPizzaGrid();
    return ModifierPizzaGrid;
})();
var ModifierHidden = /* #__PURE__ */ (function () {
    function ModifierHidden() {

    };
    ModifierHidden.value = new ModifierHidden();
    return ModifierHidden;
})();
var NotIncluded = /* #__PURE__ */ (function () {
    function NotIncluded() {

    };
    NotIncluded.value = new NotIncluded();
    return NotIncluded;
})();
var UnlimitedExchange = /* #__PURE__ */ (function () {
    function UnlimitedExchange() {

    };
    UnlimitedExchange.value = new UnlimitedExchange();
    return UnlimitedExchange;
})();
var ExchangeWithClamp = /* #__PURE__ */ (function () {
    function ExchangeWithClamp() {

    };
    ExchangeWithClamp.value = new ExchangeWithClamp();
    return ExchangeWithClamp;
})();
var AdditionOnly = /* #__PURE__ */ (function () {
    function AdditionOnly() {

    };
    AdditionOnly.value = new AdditionOnly();
    return AdditionOnly;
})();
var Modifier = function (x) {
    return x;
};
var newtypeModifier_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeModifierItem_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeModifierItemSectio = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldModifierItemSecti = function (dictHasField) {
    return dictHasField;
};
var hasFieldModifierItem = function (dictHasField) {
    return dictHasField;
};
var hasFieldModifier = function (dictHasField) {
    return dictHasField;
};
var eqModifierVatRate = {
    eq: function (x) {
        return function (y) {
            if (x instanceof IncludedInProduct && y instanceof IncludedInProduct) {
                return true;
            };
            if (x instanceof Separate && y instanceof Separate) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_Taxes.eqVatRate)(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var eqModifierItem = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Map_Serialized.eqMap(Restaumatic_Menu_V2_Types_Allergen.eqAllergen)(Restaumatic_Menu_V2_Types_Allergen.eqAllergenConcentration))(x.allergens)(y.allergens) && Data_Eq.eq(Restaumatic_Menu_V2_Types_Availability.eqAvailability)(x.availability)(y.availability) && Data_Eq.eq(Restaumatic_Menu_V2_Types_Parametric_Parametric.eqParametric(Data_Eq.eqBoolean))(x.availableWhen)(y.availableWhen) && x.defaultSelection === y.defaultSelection && x.irremovable === y.irremovable && Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.name)(y.name) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_PackagingContainer.eqPackagingContainersConf))(x.packagingContainersConfig)(y.packagingContainersConfig) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Photo.eqPhoto))(x.photo)(y.photo) && Data_Eq.eq(Restaumatic_Menu_V2_Types_Parametric_Parametric.eqParametric(Data_Money_Rounded.eqMoney))(x.price)(y.price);
        };
    }
};
var eqModifierItemSection = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Map_Ordered.eqOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(eqModifierItem))(x.items)(y.items) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString)))(x.name)(y.name) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Photo.eqPhoto))(x.photo)(y.photo);
        };
    }
};
var eqModifierDisplayMode = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ModifierList && y instanceof ModifierList) {
                return true;
            };
            if (x instanceof ModifierCheckboxList && y instanceof ModifierCheckboxList) {
                return true;
            };
            if (x instanceof ModifierRadioButtonList && y instanceof ModifierRadioButtonList) {
                return true;
            };
            if (x instanceof ModifierPizzaGrid && y instanceof ModifierPizzaGrid) {
                return true;
            };
            if (x instanceof ModifierHidden && y instanceof ModifierHidden) {
                return true;
            };
            return false;
        };
    }
};
var eqDefaultModifierItemsExc = {
    eq: function (x) {
        return function (y) {
            if (x instanceof NotIncluded && y instanceof NotIncluded) {
                return true;
            };
            if (x instanceof UnlimitedExchange && y instanceof UnlimitedExchange) {
                return true;
            };
            if (x instanceof ExchangeWithClamp && y instanceof ExchangeWithClamp) {
                return true;
            };
            if (x instanceof AdditionOnly && y instanceof AdditionOnly) {
                return true;
            };
            return false;
        };
    }
};
var eqModifier = {
    eq: function (x) {
        return function (y) {
            return x.adminNote === y.adminNote && Data_Eq.eq(Restaumatic_Menu_V2_Types_Parametric_Parametric.eqParametric(Data_Eq.eqBoolean))(x.availableWhen)(y.availableWhen) && Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.defaultPriceParameters)(y.defaultPriceParameters) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString)))(x.description)(y.description) && Data_Eq.eq(eqModifierDisplayMode)(x.displayMode)(y.displayMode) && x.divisible === y.divisible && Data_Eq.eq(eqDefaultModifierItemsExc)(x.exchangePolicy)(y.exchangePolicy) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqInt))(x.maxDuplicatesPerItem)(y.maxDuplicatesPerItem) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqInt))(x.maxItems)(y.maxItems) && x.minItems === y.minItems && Data_Eq.eq(eqModifierVatRate)(x.modifierVatRate)(y.modifierVatRate) && Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.name)(y.name) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Photo.eqPhoto))(x.photo)(y.photo) && Data_Eq.eq(Data_Eq.eqArray(eqModifierItemSection))(x.sections)(y.sections) && Data_Eq.eq(Restaumatic_Menu_V2_Types_Parametric_Parametric.eqParametric(Data_Eq.eqBoolean))(x.userEditableWhen)(y.userEditableWhen) && Data_Eq.eq(Restaumatic_Menu_V2_Types_Parametric_Parametric.eqParametric(Data_Eq.eqBoolean))(x.userInputRequiredWhen)(y.userInputRequiredWhen);
        };
    }
};
var genericModifierVatRate = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return IncludedInProduct.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new Separate(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Modifier (line 29, column 1 - line 29, column 85): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof IncludedInProduct) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Separate) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Modifier (line 29, column 1 - line 29, column 85): " + [ x.constructor.name ]);
    }
};
var showModifierVatRate = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericModifierVatRate)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "IncludedInProduct";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_Taxes.showVatRate))({
        reflectSymbol: function () {
            return "Separate";
        }
    })))
};
var unscrambleDecodeModifierVatRate = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericModifierVatRate)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "IncludedInProduct";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Separate";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate)))))(Unscramble_Generic.defaultOptions)
};
var genericModifierItemSection = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericModifierItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showModifierItem = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericModifierItem)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "allergens";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "availableWhen";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "defaultSelection";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "irremovable";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "packagingContainersConfig";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "price";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.showParametric(Data_Money_Rounded.showMoney)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Photo.showPhoto)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_PackagingContainer.showPackagingContainersConfig)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(Data_Show.showBoolean))(Data_Show.showInt))(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.showParametric(Data_Show.showBoolean)))(Restaumatic_Menu_V2_Types_Availability.showAvailability))(/* #__PURE__ */ Data_Map_Serialized.showMap(Restaumatic_Menu_V2_Types_Allergen.showAllergen)(Restaumatic_Menu_V2_Types_Allergen.showAllergenConcentration)))))({
        reflectSymbol: function () {
            return "ModifierItem";
        }
    }))
};
var showModifierItemSection = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericModifierItemSection)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Photo.showPhoto)))(/* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))))(/* #__PURE__ */ Data_Map_Ordered.showOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(showModifierItem)))))({
        reflectSymbol: function () {
            return "ModifierItemSection";
        }
    }))
};
var unscrambleDecodeModifierItem = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericModifierItem)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "allergens";
        }
    })(/* #__PURE__ */ Data_Map_Serialized.udecodeMap(Restaumatic_Menu_V2_Types_Allergen.ordAllergen)(Restaumatic_Menu_V2_Types_Allergen.ufromJSONKeyAllergen)(Restaumatic_Menu_V2_Types_Allergen.unscrambleDecodeAllergenConcentration))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "availability";
        }
    })(Restaumatic_Menu_V2_Types_Availability.unscrambleDecodeAvailability)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "availableWhen";
        }
    })(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.udecodeParametric(Unscramble.decodeBoolean1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "defaultSelection";
        }
    })(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "irremovable";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "packagingContainersConfig";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_PackagingContainer.unscrambleDecodePackagingContainersConfig))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Photo.unscrambleDecodePhoto))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.udecodeParametric(Data_Money_Rounded.udecodeMoney))(Unscramble.decodeRecordNil)))))))))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeModifierItemSection = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericModifierItemSection)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Data_Map_Ordered.udecodeMap(unscrambleDecodeModifierItem)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1)))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Photo.unscrambleDecodePhoto))(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var genericModifierDisplayMode = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return ModifierList.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return ModifierCheckboxList.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return ModifierRadioButtonList.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return ModifierPizzaGrid.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return ModifierHidden.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Modifier (line 99, column 1 - line 99, column 93): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ModifierList) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ModifierCheckboxList) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof ModifierRadioButtonList) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof ModifierPizzaGrid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof ModifierHidden) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Modifier (line 99, column 1 - line 99, column 93): " + [ x.constructor.name ]);
    }
};
var showModifierDisplayMode = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericModifierDisplayMode)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ModifierList";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ModifierCheckboxList";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ModifierRadioButtonList";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ModifierPizzaGrid";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ModifierHidden";
        }
    }))))))
};
var unscrambleDecodeModifierDisplayMode = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericModifierDisplayMode)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ModifierList";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ModifierCheckboxList";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ModifierRadioButtonList";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ModifierPizzaGrid";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ModifierHidden";
        }
    }))))))(Unscramble_Enum.defaultEnumOptions)
};
var genericModifier = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericDefaultModifierItemsExchangePolicy = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return NotIncluded.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return UnlimitedExchange.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return ExchangeWithClamp.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return AdditionOnly.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Modifier (line 156, column 1 - line 156, column 123): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NotIncluded) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof UnlimitedExchange) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof ExchangeWithClamp) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof AdditionOnly) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Modifier (line 156, column 1 - line 156, column 123): " + [ x.constructor.name ]);
    }
};
var showDefaultModifierItemsExchangePolicy = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDefaultModifierItemsExchangePolicy)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "NotIncluded";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "UnlimitedExchange";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ExchangeWithClamp";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "AdditionOnly";
        }
    })))))
};
var showModifier = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericModifier)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "adminNote";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "availableWhen";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "defaultPriceParameters";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "displayMode";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "divisible";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "exchangePolicy";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "maxDuplicatesPerItem";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "maxItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "minItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "modifierVatRate";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "sections";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "userEditableWhen";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "userInputRequiredWhen";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.showParametric(Data_Show.showBoolean)))(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.showParametric(Data_Show.showBoolean)))(/* #__PURE__ */ Data_Show.showArray(showModifierItemSection)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Photo.showPhoto)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(showModifierVatRate))(Data_Show.showInt))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showInt)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showInt)))(showDefaultModifierItemsExchangePolicy))(Data_Show.showBoolean))(showModifierDisplayMode))(/* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.showParametric(Data_Show.showBoolean)))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "Modifier";
        }
    }))
};
var unscrambleDecodeDefaultModifierItemsExchangePolicy = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericDefaultModifierItemsExchangePolicy)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "NotIncluded";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "UnlimitedExchange";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ExchangeWithClamp";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "AdditionOnly";
        }
    })))))(Unscramble_Enum.defaultEnumOptions)
};
var unscrambleDecodeModifier = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericModifier)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "adminNote";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "availableWhen";
        }
    })(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.udecodeParametric(Unscramble.decodeBoolean1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "defaultPriceParameters";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1)))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "displayMode";
        }
    })(unscrambleDecodeModifierDisplayMode)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "divisible";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "exchangePolicy";
        }
    })(unscrambleDecodeDefaultModifierItemsExchangePolicy)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "maxDuplicatesPerItem";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeInt1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "maxItems";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeInt1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "minItems";
        }
    })(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "modifierVatRate";
        }
    })(unscrambleDecodeModifierVatRate)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Photo.unscrambleDecodePhoto))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "sections";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeModifierItemSection))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "userEditableWhen";
        }
    })(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.udecodeParametric(Unscramble.decodeBoolean1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "userInputRequiredWhen";
        }
    })(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.udecodeParametric(Unscramble.decodeBoolean1))(Unscramble.decodeRecordNil))))))))))))))))))))(Unscramble_Generic.defaultOptions)
};
var encodeModifierVatRate = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericModifierVatRate)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "IncludedInProduct";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Separate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate)))))
};
var encodeModifierItem = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericModifierItem)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ModifierItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.encodeParametric(Data_Money_Rounded.encodeMoney)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney))))))({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Photo.encodePhoto))))({
        reflectSymbol: function () {
            return "packagingContainersConfig";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_PackagingContainer.encodePackagingContainersConfig))))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "irremovable";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "defaultSelection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "availableWhen";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.encodeParametric(Foreign_Generic_Class.booleanEncode)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Availability.encodeAvailability)))({
        reflectSymbol: function () {
            return "allergens";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Map_Serialized.encodeMap(Restaumatic_Menu_V2_Types_Allergen.asJSONKeyAllergen)(Restaumatic_Menu_V2_Types_Allergen.encodeAllergenConcentration)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Allergen.encodeAllergenConcentration)))))))))
};
var encodeModifierItemSection = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericModifierItemSection)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ModifierItemSection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Photo.encodePhoto))))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode)))))({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Map_Ordered.encodeMap(/* #__PURE__ */ Data_Tuple_T2.encodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeModifierItem))))))))))
};
var encodeModifierDisplayMode = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericModifierDisplayMode)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ModifierList";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ModifierCheckboxList";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ModifierRadioButtonList";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ModifierPizzaGrid";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ModifierHidden";
        }
    }))))))
};
var encodeDefaultModifierItemsExchangePolicy = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericDefaultModifierItemsExchangePolicy)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "NotIncluded";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "UnlimitedExchange";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ExchangeWithClamp";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "AdditionOnly";
        }
    })))))
};
var encodeModifier = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericModifier)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Modifier";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "userInputRequiredWhen";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.encodeParametric(Foreign_Generic_Class.booleanEncode)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))({
        reflectSymbol: function () {
            return "userEditableWhen";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.encodeParametric(Foreign_Generic_Class.booleanEncode)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))({
        reflectSymbol: function () {
            return "sections";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeModifierItemSection))))({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Photo.encodePhoto))))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "modifierVatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeModifierVatRate)))({
        reflectSymbol: function () {
            return "minItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "maxItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.intEncode))))({
        reflectSymbol: function () {
            return "maxDuplicatesPerItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.intEncode))))({
        reflectSymbol: function () {
            return "exchangePolicy";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeDefaultModifierItemsExchangePolicy)))({
        reflectSymbol: function () {
            return "divisible";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "displayMode";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeModifierDisplayMode)))({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode)))))({
        reflectSymbol: function () {
            return "defaultPriceParameters";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "availableWhen";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.encodeParametric(Foreign_Generic_Class.booleanEncode)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))({
        reflectSymbol: function () {
            return "adminNote";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var decodeModifierVatRate = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericModifierVatRate)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "IncludedInProduct";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Separate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))(Foreign_Generic_Class.genericCountArgsArgument)))
};
var decodeModifierItem = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericModifierItem)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ModifierItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.decodeParametric(Data_Money_Rounded.decodeMoney)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney)))))())({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Photo.decodePhoto)))())({
        reflectSymbol: function () {
            return "packagingContainersConfig";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_PackagingContainer.decodePackagingContainersConfig)))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "irremovable";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "defaultSelection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
        reflectSymbol: function () {
            return "availableWhen";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.decodeParametric(Foreign_Generic_Class.booleanDecode)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode)))))())({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Availability.decodeAvailability))())({
        reflectSymbol: function () {
            return "allergens";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Map_Serialized.decodeMap(Restaumatic_Menu_V2_Types_Allergen.ordAllergen)(Restaumatic_Menu_V2_Types_Allergen.asJSONKeyAllergen)(Restaumatic_Menu_V2_Types_Allergen.decodeAllergenConcentration)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Allergen.decodeAllergenConcentration)))))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeModifierItemSection = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericModifierItemSection)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ModifierItemSection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Photo.decodePhoto)))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode))))())({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Map_Ordered.decodeMap(/* #__PURE__ */ Data_Tuple_T2.decodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeModifierItem))))(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeModifierDisplayMode = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericModifierDisplayMode)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ModifierList";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ModifierCheckboxList";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ModifierRadioButtonList";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ModifierPizzaGrid";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ModifierHidden";
        }
    }))))))
};
var decodeDefaultModifierItemsExchangePolicy = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericDefaultModifierItemsExchangePolicy)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "NotIncluded";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "UnlimitedExchange";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ExchangeWithClamp";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "AdditionOnly";
        }
    })))))
};
var decodeModifier = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericModifier)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Modifier";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "userInputRequiredWhen";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.decodeParametric(Foreign_Generic_Class.booleanDecode)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode)))))())({
        reflectSymbol: function () {
            return "userEditableWhen";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.decodeParametric(Foreign_Generic_Class.booleanDecode)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode)))))())({
        reflectSymbol: function () {
            return "sections";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeModifierItemSection)))())({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Photo.decodePhoto)))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "modifierVatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeModifierVatRate))())({
        reflectSymbol: function () {
            return "minItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
        reflectSymbol: function () {
            return "maxItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.intDecode)))())({
        reflectSymbol: function () {
            return "maxDuplicatesPerItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.intDecode)))())({
        reflectSymbol: function () {
            return "exchangePolicy";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeDefaultModifierItemsExchangePolicy))())({
        reflectSymbol: function () {
            return "divisible";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "displayMode";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeModifierDisplayMode))())({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode))))())({
        reflectSymbol: function () {
            return "defaultPriceParameters";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "availableWhen";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_Menu_V2_Types_Parametric_Parametric.decodeParametric(Foreign_Generic_Class.booleanDecode)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode)))))())({
        reflectSymbol: function () {
            return "adminNote";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    IncludedInProduct,
    Separate,
    ModifierItemSection,
    ModifierItem,
    ModifierList,
    ModifierCheckboxList,
    ModifierRadioButtonList,
    ModifierPizzaGrid,
    ModifierHidden,
    Modifier,
    NotIncluded,
    UnlimitedExchange,
    ExchangeWithClamp,
    AdditionOnly,
    genericModifierVatRate,
    eqModifierVatRate,
    showModifierVatRate,
    encodeModifierVatRate,
    decodeModifierVatRate,
    unscrambleDecodeModifierVatRate,
    genericModifierItemSection,
    eqModifierItemSection,
    showModifierItemSection,
    encodeModifierItemSection,
    decodeModifierItemSection,
    unscrambleDecodeModifierItemSection,
    hasFieldModifierItemSecti,
    newtypeModifierItemSectio,
    genericModifierItem,
    eqModifierItem,
    showModifierItem,
    encodeModifierItem,
    decodeModifierItem,
    unscrambleDecodeModifierItem,
    hasFieldModifierItem,
    newtypeModifierItem_,
    genericModifierDisplayMode,
    eqModifierDisplayMode,
    showModifierDisplayMode,
    encodeModifierDisplayMode,
    decodeModifierDisplayMode,
    unscrambleDecodeModifierDisplayMode,
    genericModifier,
    eqModifier,
    showModifier,
    encodeModifier,
    decodeModifier,
    unscrambleDecodeModifier,
    hasFieldModifier,
    newtypeModifier_,
    genericDefaultModifierItemsExchangePolicy,
    eqDefaultModifierItemsExc,
    showDefaultModifierItemsExchangePolicy,
    encodeDefaultModifierItemsExchangePolicy,
    decodeDefaultModifierItemsExchangePolicy,
    unscrambleDecodeDefaultModifierItemsExchangePolicy
};
//# sourceMappingURL=index.js.map
